export const ADMIN_TOP_BANNER = "/admin/main/topBanners";
export const ADMIN_INTRODUCE = "/admin/main/intro";
export const ADMIN_INTRODUCE_2 = "/admin/main/intro2";

export const ADMIN_MAIN_MENU = "/admin/menu/main";
export const ADMIN_SUB_MENU = "/admin/menu/sub";

export const ADMIN_BOARD_PRODUCT = "/admin/board/product";
export const ADMIN_BOARD_DETAIL = "/admin/board";
export const ADMIN_BOARD_BOARD = "/admin/board/board";
